import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import { fetchEmployee } from '../../api/employees';
import Attachments from '../Attachments';

export class EmployeeAttachments extends Component {

  componentWillMount() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
    this.moveToEdit = this.moveToEdit.bind(this);
  }

  moveToEdit() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.moveToEdit(id);
  }

  render() {
    const id = path(['match', 'params', 'id'], this.props);
    const employee = path(['employees', 'currentEmployee'], this.props);
    const label = (employee ? `${employee.firstname} ${employee.lastname}` : 'Edit Employee');
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/employees', icon: 'people', name: 'Employees' },
          { eventOnClick: this.moveToEdit, icon: 'account_circle', name: label },
          { icon: 'attach_file', name: 'Add File' },
        ]} />

        <Attachments attachmentType="employee" id={id}></Attachments>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataById: (id) => {
      fetchEmployee(id)(dispatch);
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/employee/' + id));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAttachments);



// WEBPACK FOOTER //
// ./src/containers/EmployeeAttachments/index.js